












// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditFollowers from '@/components/flux/edit/EditFollowers.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { TypeOffre } from '@/enum/TypeOffre'

@Component({
  name: 'ReadFollowers',    
  components:{EditFollowers},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    flux:{
      type:Object,
      default:getDefaultAloFlux()
    },
    editable:{
      type:Boolean,
      default:true      
    }    
  }
})
export default class ReadFollowers extends Vue {
  
  private flux!:AloFlux
  private loading!:boolean  
  private editable!:boolean  

  edit() { 
    (this.$refs.editFollowers as EditFollowers).edit(this.flux)
  }

}
